/*
* 金額フォーマッタ
*/
export default class CurrencyFormatter {
  constructor() {
    this.currencyInputField = document.getElementById('currency-input');
    this.formattedCurrencyInputField = document.getElementById('formatted-currency-output');
  }

  attachEvent() {
    if (!this.currencyInputField || !this.formattedCurrencyInputField) {
      return;
    }

    this.formattedCurrencyInputField.addEventListener('blur', (e) => {
      let value = e.target.value.replace(/,/g, '');
      if (value) {
        value = parseFloat(value);
        if (!Number.isNaN(value)) {
          this.formattedCurrencyInputField.value = value.toLocaleString();
          this.currencyInputField.value = value;
        } else {
          this.formattedCurrencyInputField.value = '0';
          this.currencyInputField.value = 0;
        }
      }
    });

    // ページ読み込み時に既存の値を表示する
    const initialValue = this.currencyInputField.value;
    if (initialValue) {
      this.formattedCurrencyInputField.value = Number(initialValue).toLocaleString();
    }
  }
}
